module.exports = __webpack_public_path__ + "img/1.2796ea38.jpg";